import {
    addApplicationActivity,
    addJdOpsProduct,
    addPlantingActivity,
    addSeedCost,
    addTillageWork,
} from "../slices/addCost.slice";
import {
    AddJdOpsProductT,
    ApplicationActivityT,
    PlantingActivityT,
    SeedCostT,
    TillageWorkT,
} from "../types/addCost";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { RootState } from "../store";
import { toast } from "react-toastify";

export const useAddCost = () => {
    const dispatch = useAppDispatch();

    const executeAddAction = async <T>(
        actionCreator: (payload: T) => any,
        data: T,
        successMessage: string,
        fallbackErrorMessage: string
    ) => {
        try {
            await dispatch(actionCreator(data)).unwrap();
            toast.success(successMessage);
            return true;
        } catch (error: unknown) {
            if (error instanceof Error && error.message) {
                toast.error(error.message);
            } else if (typeof error === "string" && error) {
                toast.error(error);
            } else if (error && typeof error === "object" && "message" in error) {
                toast.error(String((error as { message: unknown }).message));
            } else {
                toast.error(fallbackErrorMessage);
            }
            return false;
        }
    };

    const handleAddJdOpsProduct = async (data: AddJdOpsProductT) => {
        return executeAddAction(
            addJdOpsProduct,
            data,
            "JD Ops product mapping added successfully!",
            "Failed to add JD Ops product mapping!"
        );
    };

    const handleAddSeedCost = async (data: SeedCostT) => {
        return executeAddAction(
            addSeedCost,
            data,
            "Seed cost added successfully!",
            "Failed to add seed cost!"
        );
    };

    const handleAddApplicationActivity = async (data: ApplicationActivityT) => {
        return executeAddAction(
            addApplicationActivity,
            data,
            "Application cost added successfully!",
            "Failed to add application cost!"
        );
    };

    const handleAddPlantingActivity = async (data: PlantingActivityT) => {
        return executeAddAction(
            addPlantingActivity,
            data,
            "Planting cost added successfully!",
            "Failed to add planting cost!"
        );
    };

    const handleAddTillageWork = async (data: TillageWorkT) => {
        return executeAddAction(
            addTillageWork,
            data,
            "Tillage work added successfully!",
            "Failed to add tillage work!"
        );
    };

    const addCostState = useAppSelector((state: RootState) => state.addCost);

    return {
        addCostState,
        handleAddJdOpsProduct,
        handleAddSeedCost,
        handleAddApplicationActivity,
        handleAddPlantingActivity,
        handleAddTillageWork,
    };
};